import { Link } from 'react-router-dom';
import s from './Logo.module.scss';

const Logo = ({ color, className = '' }) => {
  const isDark = color === 'dark';

  return (
    <Link
      to="/"
      className={`
        ${s.root}
        ${isDark ? s.dark : ''}
        ${className}
      `}
      style={{ color: isDark ? '#071b45' : '#fff' }}
      aria-label="Premium Tour Miyakoisland"
    >
      Premium Tour Miyakoisland
    </Link>
  );
};

export default Logo;
